export default __webpack_public_path__ + "static/media/alcaldias_banner3.9a93a419.png";